import React, { useState } from "react";
import Tabs from "components/v2/Tabs/Tabs";
import Tab from "components/v2/Tabs/components/Tab";
import TextFilter from "./TextFilter";
import SearchableTextFilter from "./SearchableTextFilter";
import MultiSelectFilter from "./MultiSelectFilter";

type BaseFilterProps = {
  buttonGroupOptions: { value: any; label: string }[];
  setFilters: Function;
  currentFilters: Record<string, any>;
};

type TextFilterProps = BaseFilterProps & {
  type: "text";
  options?: never;
  isSearchable?: never;
  eventContext?: never;
};

type SearchableTextFilterProps = BaseFilterProps & {
  type: "text";
  options: { label: string; value: string | number }[];
  isSearchable?: never;
  eventContext?: never;
};

type MultiSelectFilterProps = BaseFilterProps & {
  type: "multiselect";
  options: { label: string; value: string | number }[];
  isSearchable?: boolean;
  eventContext: any; // Adjust this type according to your actual context type
};

type TabsFilterProps = TextFilterProps | SearchableTextFilterProps | MultiSelectFilterProps;

function TabsFilter({
  type,
  buttonGroupOptions,
  setFilters,
  currentFilters,
  options,
  isSearchable,
  eventContext,
}: TabsFilterProps) {
  const [selectedTab, setSelectedTab] = useState<any>(buttonGroupOptions[0].value);

  const handleSelectTab = (key: string) => {
    const newFilters = { ...currentFilters };
    delete newFilters[selectedTab];
    setSelectedTab(key);
    setFilters({ ...newFilters, [key]: [] });
  };

  return (
    <>
      <div className="mb-xl">
        <Tabs type="button-white-border" isFullWidth activeKey={selectedTab} onSelect={(key: any) => handleSelectTab(key)}>
          {buttonGroupOptions.map((option) => (
            <Tab key={option.value} eventKey={option.value} title={option.label}>
              <div />
            </Tab>
          ))}
        </Tabs>
      </div>
      {renderFilterComponent(type)}
    </>
  );

  function renderFilterComponent(type: TabsFilterProps["type"]) {
    switch (type) {
      case "text":
        return options ? (
          <SearchableTextFilter
            currentFilters={currentFilters}
            setFilters={setFilters}
            filterKey={selectedTab}
            options={options[selectedTab]}
          />
        ) : (
          <TextFilter currentFilters={currentFilters} setFilters={setFilters} filterKey={selectedTab} />
        );
      case "multiselect":
        return (
          options && (
            <MultiSelectFilter
              currentFilters={currentFilters}
              setFilters={setFilters}
              options={options[selectedTab]}
              filterKey={selectedTab}
              searchable={isSearchable}
              eventContext={eventContext}
            />
          )
        );
      default:
        return null;
    }
  }
}

export default TabsFilter;
